var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoading)?_c('div',[_c('blurryLoader')],1):[_c('router-view',{attrs:{"baseUrl":_vm.baseUrl,"stripeKey":_vm.StripeKey,"googleMapsApiKey":_vm.googleMapsApiKey},on:{"add-to-cart":_vm.addItemToCart}}),_c('ShoppingCart'),(_vm.reportPage)?_c('footer-section'):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }